export interface ISalesOfferSummary {
  totalOrders: number;
  totalOrdersWithOffer: number;
  totalOrdersWithoutOffer: number;
  avgAmount: number;
  avgAmountWithOffer: number;
  avgAmountWithoutOffer: number;
  avgDiscount: number;
  firstOrderDate: number;
  totalClients?: number;
  clientsUseOffer?: number;
  clientsWithoutUseOffer?: number;
  lastOrderDate: number;
  totalAmount: number;
  totalAmountWithOffer: number;
  totalAmountWithoutOffer: number;
  totalDiscount: number;
  usagePercentage: number;

  totalOrdersWithOffers: number;
  totalAmountWithOffers: number;
  interval: string
}

export interface ISalesOfferHistogram {
  avgAmount: number;
  interval: string;
  count: number;
  countWithOffer: number;
  totalOrdersWithOffer: number;
  total: number;
  totalAmount: number;
  totalAmountWithOffer: number;
}

export interface ISalesOfferReactiveClients {
  count: number;
  range: string;
}

export enum ANALYTIC_OFFER_METRIC {
  SUMMARY = 'offers-usage-summary',
  BY_TYPE = 'offers-by-type',
  COMPARATIVE = 'offers-comparative',
  HISTOGRAM = 'offers-usage-histogram',
  STATUS_SUMMARY = 'offers-status-summary',
}
